import { PropTypes } from "prop-types"
import classNames from "classnames"

export const InputTextArea = ({
  className,
  errorId,
  hasError,
  disabled,
  ariaDescribedBy,
  ...otherProps
}) => {
  return (
    <textarea
      className={classNames("oj-input-text-area", className, { "state-disabled": disabled })}
      disabled={disabled}
      {...otherProps}
      aria-invalid={hasError}
      aria-describedby={hasError ? errorId : ariaDescribedBy}
    />
  )
}

InputTextArea.propTypes = {
  ariaDescribedBy: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  errorId: PropTypes.string,
  hasError: PropTypes.bool,
  onChange: PropTypes.func
}

export default InputTextArea
